import React from 'react';
import I18n from 'i18n-js';
import classNames from 'classnames';

import { buttonClassName, RCChip, RCDrawer, RCTextWithIcon, useMediaQuery } from '@reverbdotcom/cadence/components';
import { SearchResultFacetGroup } from '@reverbdotcom/commons/src/gql/graphql';
import { SlidersHorizontalIcon } from '@reverbdotcom/cadence/icons/react';
import { ClearFacetsButton } from './facet_group_row';
import { SIDEBAR_FACET_MAPPING, allSelectedFacets } from './facet';

interface IProps {
  facetGroups?: SearchResultFacetGroup[];
  loading?: boolean;
  query?: string;
  resultsTotal?: number;
}

export function FacetSidebar({
  facetGroups = [],
  loading = false,
  query = '',
  resultsTotal = null,
}: IProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const isMobile = useMediaQuery('mobile');
  const buttonText = !resultsTotal ?
    I18n.t('commons.marketplaceFilters.viewResults') :
    I18n.t('commons.marketplaceFilters.showResultsCount',
      { count: I18n.toNumber(resultsTotal, { precision: 0 }) },
    );

  const totalSelectedFacets = allSelectedFacets(facetGroups).length;
  let allFiltersText = I18n.t('commons.marketplaceFilters.allFilters');
  if (isMobile) {
    allFiltersText = totalSelectedFacets > 0 ? `(${totalSelectedFacets})` : '';
  }

  const classes = classNames(
    'facet-sidebar',
    { 'facet-sidebar--loading': loading },
  );

  return (
    <div className="marketplace-filter marketplace-filter--all-filters">
      <RCChip
        loading={loading}
        onClick={() => setIsOpen(true)}
      >
        <RCTextWithIcon
          svgComponent={SlidersHorizontalIcon}
          placement="left"
          size="large"
        >
          {allFiltersText}
        </RCTextWithIcon>
      </RCChip>
      <RCDrawer
        isOpen={isOpen}
        onOpenChange={(state) => setIsOpen(state)}
        title={I18n.t('commons.marketplaceFilters.filterYourSearch')}
        actions={{
          primary: {
            buttonText: buttonText,
            fullWidth: true,
          },
        }}
      >
        <div className="bdb-1 bd-color-primary pb-4">
          <ClearFacetsButton
            facetGroups={facetGroups}
            query={query}
            classNames={buttonClassName({ size: 'small' })}
          />
        </div>
        <div className={classes}>
          <div className="facet-sidebar__contents">
            {
              facetGroups.map(facetGroup => {
                const FacetComponent = SIDEBAR_FACET_MAPPING[facetGroup.widgetType];
                if (!FacetComponent || !facetGroup.facets.length) return null;
                return (
                  <div className="facet-container facet-container--no-margin" key={facetGroup.displayName}>
                    <FacetComponent facetGroup={facetGroup} sidebar />
                  </div>
                );
              })
            }
          </div>
        </div>
      </RCDrawer>
    </div>
  );
}
